/** Blog list category tabs (English-only for now). */
export const BLOG_CATEGORIES = [
  'All',
  'AI Video Guides',
  'Tutorials',
  'Use Cases',
  'AI Tools & Comparisons',
  'Tips & Ideas',
]

export const BLOG_IMAGE_PLACEHOLDER = 'https://static.lip-sync.ai/lipsync/blog/1.webp'
